module.exports = __webpack_public_path__ + "static/img/p1_2.bc7d54b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product/p1_2.png
// module id = CC8L
// module chunks = 1